import gql from "graphql-tag";

export const managersQuery = gql`
  query managers($filters: Filter, $page: Int, $perPage: Int) {
    managers(
      orderBy: { column: "isActive", direction: desc }
      filters: $filters
      page: $page
      first: $perPage
    ) {
      paginatorInfo {
        currentPage
        perPage
        total
        lastPage
      }
      data {
        id
        oneCId
        name
        isActive
        image {
          link
        }
        regions {
          id
          name
        }
        email
        phone
      }
    }
  }
`;

export { allManagersQuery } from "@/gql/managers.queries";

export const allCompaniesQuery = gql`
  query allCompanies {
    allCompanies {
      id
      name
    }
  }
`;

export const allCustomersQuery = gql`
  query allCustomer {
    allCustomer {
      id
      name
    }
  }
`;
